export const getWorkflowInstanceName = (workflow: string, id: string) =>
  `workflows/${workflow}/instances/${id}`;

export const getIsEditDisabled =
  (disabledStates: string[]) =>
  (
    workflowInstance?: Maybe<{
      state: string;
      lockedDataKeys: string[];
    }>,
    key?: string,
  ) =>
    Boolean(
      (workflowInstance && disabledStates.includes(workflowInstance.state)) ||
        (key !== undefined && workflowInstance?.lockedDataKeys?.includes(key)),
    );

export const getHasWorkflowLaunched = (workflowInstance: {
  state: string;
  stateHistory?: Array<{ state?: string | null }> | null;
}): boolean => {
  const wasLive = workflowInstance.stateHistory?.some(e => e.state === 'live');
  const isLive = workflowInstance.state === 'live';

  return !(workflowInstance.state === 'draft' || (!wasLive && !isLive));
};
